import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { api } from "../utils/Api";
import {
	Typography,
	Flex,
	Table,
	Row,
	Col,
	Button,
	Form,
	DatePicker,
	Tag,
	notification,
	Select,
	Modal,
} from "antd";
import Layout from "../layout/Layout";
import { CustomSearch, CustomSpinner } from "../utils/CustomComponents";
import dayjs from "dayjs";
import { PlusCircleOutlined, UnorderedListOutlined } from "@ant-design/icons";
import CreateCustomerTask from "./CreateCustomerTask";
import TaskType from "./TaskType";
import { Link } from "react-router-dom";
const { Text } = Typography;

const ProspectDashboard = ({ history }) => {
	const [loading, setLoading] = useState(true);
	const [loadingTable, setLoadingTable] = useState(false);
	const [list, setList] = useState([]);
	const [sellerList, setSellerList] = useState([]);
	const [seller, setSeller] = useState(null);
	const [modalTaskOpen, setModalTaskOpen] = useState(false);
	const [modalTaskTypeOpen, setModalTaskTypeOpen] = useState(false);
	const [sellerDisabled, setSellerDisabled] = useState(false);
	const [apiNotification, contextHolder] = notification.useNotification();
	const typeRef = useRef(null);

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	useEffect(() => {
		getSellerList();
	}, []);

	/**
	 ** Options header (columns)
	 */
	const columns = [
		{
			title: "Customer",
			dataIndex: "customer",
			key: "customer",
			render: (value, values) => {
				if (!values.registrationComplete) return <Text>{value}</Text>;
				return <Link to={`/client/${values.id}`}>{value}</Link>;
			},
		},
		{
			title: "Ranking",
			dataIndex: "ranking",
			key: "ranking",
			render: (value) => {
				let color = "";
				switch (value) {
					case "A":
						color = "purple";
						break;
					case "B":
						color = "blue";
						break;
					case "C":
						color = "green";
						break;
					case "D":
						color = "red";
						break;
					default:
						color = "default";
						break;
				}
				return <Tag color={color}>{value || "None"}</Tag>;
			},
		},
		{
			title: () => {
				return (
					<Row gutter={16} align={"middle"}>
						<Col>
							<Text>Contact</Text>
						</Col>
						<Col>
							<Button
								type="primary"
								icon={<UnorderedListOutlined />}
								onClick={() => {
									typeRef.current = "Contact";
									setModalTaskTypeOpen(true);
								}}
								disabled={!seller}
							/>
						</Col>
					</Row>
				);
			},
			dataIndex: "contact",
			key: "contact",
			editable: true,
		},
		{
			title: () => {
				return (
					<Row gutter={16} align={"middle"}>
						<Col>
							<Text>Meeting</Text>
						</Col>
						<Col>
							<Button
								type="primary"
								icon={<UnorderedListOutlined />}
								onClick={() => {
									typeRef.current = "Meeting";
									setModalTaskTypeOpen(true);
								}}
								disabled={!seller}
							/>
						</Col>
					</Row>
				);
			},
			dataIndex: "meeting",
			key: "meeting",
			editable: true,
		},
		{
			title: () => {
				return (
					<Row gutter={16} align={"middle"}>
						<Col>
							<Text>Negotiation</Text>
						</Col>
						<Col>
							<Button
								type="primary"
								icon={<UnorderedListOutlined />}
								onClick={() => {
									typeRef.current = "Negotiation";
									setModalTaskTypeOpen(true);
								}}
								disabled={!seller}
							/>
						</Col>
					</Row>
				);
			},
			dataIndex: "negotiation",
			key: "negotiation",
			render: (value, values) => {
				if (values.registrationComplete) {
					return (
						<DatePicker
							style={{ width: "100%" }}
							format={"MM/DD/YYYY hh:mm"}
							showTime
							value={value}
							disabled={true}
							allowClear={false}
						/>
					);
				} else {
					return (
						<Button onClick={() => history.push(`/prospect/new/${values.id}`)}>
							Convert Prospect
						</Button>
					);
				}
			},
		},
		{
			title: () => {
				return (
					<Row gutter={16} align={"middle"}>
						<Col>
							<Text>Credit App</Text>
						</Col>
						<Col>
							<Button
								type="primary"
								icon={<UnorderedListOutlined />}
								onClick={() => {
									typeRef.current = "Credit App";
									setModalTaskTypeOpen(true);
								}}
								disabled={!seller}
							/>
						</Col>
					</Row>
				);
			},
			dataIndex: "creditApp",
			key: "creditApp",
			editable: true,
		},
		{
			title: "Proyect 1",
			dataIndex: "proyect1",
			key: "proyect1",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Proyect 2",
			dataIndex: "proyect2",
			key: "proyect2",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Seller",
			dataIndex: "seller",
			key: "seller",
			editable: true,
		},
	];

	const EditableCell = ({
		editMode,
		dataIndex,
		record,
		title,
		handleSave,
		children,
		sellerList,
		...restProps
	}) => {
		const [form] = Form.useForm();

		const onSaveDate = (date) => {
			handleSave(
				{
					...record,
					[dataIndex]: date || null,
					[`${dataIndex}Disabled`]: true,
				},
				dataIndex,
			);
		};

		const onSaveSelect = (value) => {
			handleSave(
				{
					...record,
					[dataIndex]: value,
				},
				dataIndex,
			);
		};

		let isDisabled = false;

		if (dataIndex === "contact") isDisabled = record.contactDisabled;
		if (dataIndex === "meeting") isDisabled = record.meetingDisabled;
		if (dataIndex === "negotiation") isDisabled = record.negotiationDisabled;
		if (dataIndex === "creditApp") isDisabled = record.creditAppDisabled;

		const email = localStorage.getItem("email");

		return (
			<td {...restProps}>
				{editMode ? (
					<Form form={form} initialValues={{ [dataIndex]: record[dataIndex] }}>
						<Form.Item
							style={{ margin: 0 }}
							name={dataIndex}
							rules={[{ required: false }]}
						>
							{dataIndex === "seller" ? (
								<Select
									style={{ width: "100%" }}
									value={record[dataIndex]}
									options={sellerList}
									disabled={
										email !== "eliud@gmail.com" &&
										email !== "ec@57concrete.com" &&
										email !== "pc@57concrete.com" &&
										email !== "jc@57concrete.com" &&
										email !== "gg@57xgroup.com" &&
										email !== "rl@57concrete.com" &&
										email !== "jh@57concrete.com" &&
										email !== "bpa@57concrete.com"
									}
									onChange={onSaveSelect}
									allowClear={false}
								/>
							) : (
								<DatePicker
									style={{ width: "100%" }}
									format={"MM/DD/YYYY hh:mm"}
									showTime
									value={record[dataIndex] ? dayjs(record[dataIndex]) : null}
									disabled={isDisabled}
									onChange={onSaveDate}
									allowClear={false}
								/>
							)}
						</Form.Item>
					</Form>
				) : (
					children
				)}
			</td>
		);
	};

	const handleSave = async (updatedCustomer, field) => {
		await updateCustomer(updatedCustomer, field);
		const updatedList = list.map((item) => {
			if (item.key !== updatedCustomer.key) return item;
			return updatedCustomer;
		});
		setList(updatedList);
	};

	const updateCustomer = async (customer, field) => {
		setLoadingTable(true);
		const url = api + `/customer/update/prospection/${customer.id}`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		let body = {};

		if (field === "contact")
			body = {
				prospectionStatus: "Contact",
				prospectionContactDate: dayjs(customer.contact).toDate(),
			};

		if (field === "meeting")
			body = {
				prospectionStatus: "Meeting",
				prospectionMeetingDate: dayjs(customer.meeting).toDate(),
			};
		if (field === "creditApp")
			body = {
				prospectionStatus: "Credit App",
				prospectionCreditAppDate: dayjs(customer.creditApp).toDate(),
			};

		if (field === "seller")
			body = {
				prospectionSeller: customer.seller,
			};

		try {
			const { data } = await axios.patch(url, body);
			if (data.success) {
				setLoadingTable(false);
				if (field === "seller") {
					getCustomerList();
				}
			} else {
				setLoadingTable(true);
			}
		} catch (err) {
			setLoadingTable(false);
			console.error(err.message);
			return null;
		}
	};

	const mergedColumns = columns.map((col) => {
		if (!col.editable) {
			return col;
		}
		return {
			...col,
			onCell: (record) => ({
				record,
				editMode: true,
				dataIndex: col.dataIndex,
				title: col.title,
				handleSave: handleSave,
			}),
		};
	});

	const getSellerList = async () => {
		setLoading(true);

		const url = api + "/user/list/57Concrete/Seller";
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			if (data.success) {
				let list = [];
				data.payload.map((item, index) => {
					list.push({
						key: index,
						value: item._id,
						label: item.name,
					});
				});
				setSellerList(list);
				const currentSeller = list.find(
					(seller) => seller.value === localStorage.getItem("userId"),
				);
				if (currentSeller) {
					setSeller(currentSeller.value);
				}
				const email = localStorage.getItem("email");
				if (
					email === "eliud@gmail.com" ||
					email === "ec@57concrete.com" ||
					email === "pc@57concrete.com" ||
					email === "jc@57concrete.com" ||
					email === "gg@57xgroup.com" ||
					email === "rl@57concrete.com" ||
					email === "jh@57concrete.com" ||
					email === "bpa@57concrete.com"
				) {
					setSellerDisabled(false);
				} else {
					setSellerDisabled(true);
				}
			} else {
				openNotification("error", "Error", data.message);
			}
			setLoading(false);
		} catch (err) {
			openNotification("error", "Error", err.message);
			return null;
		}
	};

	useEffect(() => {
		if (seller) {
			getCustomerList();
		}
	}, [seller]);

	const getCustomerList = async () => {
		setLoading(true);

		const url = api + `/customer/list/prospect/byseller/${seller}`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			let list = [];
			if (data.success) {
				data.payload.map((item, index) => {
					list.push({
						key: index,
						id: item._id,
						registrationComplete:
							item.registrationComplete === false ? false : true,
						customer: item.customerNumber
							? `${item.customerNumber} ${item.name}`
							: item.name,
						ranking: item.ranking,
						contactDisabled: item.prospectionContactDate ? true : false,
						meetingDisabled: item.prospectionMeetingDate ? true : false,
						negotiationDisabled: item.prospectionNegotiationDate ? true : false,
						creditAppDisabled: item.prospectionCreditAppDate ? true : false,
						proyect1:
							item.jobs.length > 0
								? new Intl.DateTimeFormat("en-US", {
										month: "numeric",
										year: "numeric",
										day: "numeric",
										hour: "2-digit",
										minute: "2-digit",
										second: "2-digit",
									}).format(new Date(item.jobs[0].operationsDoneDate))
								: "None",
						proyect2:
							item.jobs.length > 0 && item.jobs.length === 2
								? new Intl.DateTimeFormat("en-US", {
										month: "numeric",
										year: "numeric",
										day: "numeric",
										hour: "2-digit",
										minute: "2-digit",
										second: "2-digit",
									}).format(new Date(item.jobs[0].operationsDoneDate))
								: "None",
						contact: item.prospectionContactDate
							? dayjs(item.prospectionContactDate)
							: null,
						meeting: item.prospectionMeetingDate
							? dayjs(item.prospectionMeetingDate)
							: null,
						negotiation: item.prospectionNegotiationDate
							? dayjs(item.prospectionNegotiationDate)
							: null,
						creditApp: item.prospectionCreditAppDate
							? dayjs(item.prospectionCreditAppDate)
							: null,
						seller: item.prospectionSeller._id,
					});
				});
				setList(list);
			} else {
				openNotification("error", "Error", data.message);
			}
			setLoading(false);
		} catch (err) {
			openNotification("error", "Error", err.message);
			return null;
		}
	};

	const RenderTable = () => {
		return (
			<Flex gap={"middle"} vertical>
				<Table
					columns={mergedColumns}
					dataSource={list}
					components={{
						body: {
							cell: (props) => (
								<EditableCell {...props} sellerList={sellerList} />
							),
						},
					}}
					pagination={{
						position: ["bottomRight"],
						pageSizeOptions: [10, 20, 50, 100],
						defaultPageSize: 10,
						showSizeChanger: true,
					}}
					scroll={{
						x: true,
					}}
					style={{
						minWidth: "100%",
					}}
					loading={loadingTable}
				/>
			</Flex>
		);
	};

	const onChangeSeller = (value) => {
		setSeller(value);
		if (!value) {
			setList([]);
		}
	};

	const RenderSellers = () => {
		return (
			<Flex gap={"large"} align={"center"} justify="space-between">
				<CustomSearch
					loading={loading}
					allowClearPicker={true}
					labelPicker={"Seller"}
					optionsPicker={sellerList}
					pickerWidth={"300px"}
					pickerValue={seller}
					onChangePicker={onChangeSeller}
					disabledPicker={sellerDisabled}
				/>
				<Row gutter={16}>
					<Col>
						<Button
							type="primary"
							htmlType="button"
							size="large"
							icon={<PlusCircleOutlined />}
							onClick={() =>
								history.push("/prospect/new/pre", { sellerId: seller })
							}
						>
							New Prospect
						</Button>
					</Col>
					<Col>
						<Button
							type="dashed"
							htmlType="button"
							size="large"
							icon={<PlusCircleOutlined />}
							onClick={() => setModalTaskOpen(true)}
							disabled={!seller}
						>
							Add Task
						</Button>
					</Col>
				</Row>
			</Flex>
		);
	};

	const ModalTask = () => {
		return (
			<Modal
				title="New Task"
				open={modalTaskOpen}
				onCancel={() => setModalTaskOpen(false)}
				cancelButtonProps={{ style: { display: "none" } }}
				okButtonProps={{ style: { display: "none" } }}
				width={1000}
			>
				<CreateCustomerTask
					from={"prospect"}
					seller={seller}
					setModal={setModalTaskOpen}
				/>
			</Modal>
		);
	};

	const ModalTaskType = () => {
		return (
			<Modal
				title={`${typeRef.current} Tasks`}
				open={modalTaskTypeOpen}
				onCancel={() => setModalTaskTypeOpen(false)}
				cancelButtonProps={{ style: { display: "none" } }}
				okButtonProps={{ style: { display: "none" } }}
				width={1000}
			>
				<TaskType type={typeRef.current} seller={seller} />
			</Modal>
		);
	};

	return (
		<Layout title="Prospect" description="Dashboard" type="large">
			<Flex vertical gap={"large"}>
				<RenderSellers />
				{loading ? <CustomSpinner /> : <RenderTable />}
			</Flex>
			{contextHolder}
			<ModalTask />
			<ModalTaskType />
		</Layout>
	);
};

export default ProspectDashboard;
